import types from '../../../mutation-types';

const CONVERSATIONS_PER_PAGE = 25;

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  context.commit(types.SET_ALL_CONVERSATION, conversationList);
  if (filterType === 'new_leads') {
    context.commit(types.SET_NEW_LEAD_CONVERSATIONS, {
      conversationIds: conversationList.map(conversation => conversation.id),
      totalCount: metaData.all_count ?? conversationList.length,
      replace: Number(requestPayload.page || 1) === 1,
    });
  }
  // New leads metadata is scoped to the personal inbox and must not overwrite regular tab counts.
  if (filterType !== 'new_leads') {
    context.dispatch('conversationStats/set', metaData);
  }
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: conversationList.length < CONVERSATIONS_PER_PAGE,
  });
};
